import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../../firmwareAssignmentState/firmwareAssignmentContext';
import Button from 'components/Button/Button';
import { DownOutlined } from '@ant-design/icons';
import style from './AssignBtn.module.scss';

const AssignBtn: React.FC = () => {
	const { addSelectedFirmwareToRestaurant, IDsSelectedFirmware, IDsSelectedRestaurants } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	const getBtnStatus = () => {
		const countOfOpenTabs = Object.values(IDsSelectedRestaurants).reduce((acc, key) => {
			return key ? acc + 1 : acc;
		}, 0);
		return IDsSelectedFirmware.length < 1 || countOfOpenTabs === 0;
	};
	const isDisabled = getBtnStatus();

	return (
		<Button
			onClick={addSelectedFirmwareToRestaurant}
			disabled={isDisabled}
			data-test="AssignBtn"
			iconPosition="post"
			icon={<DownOutlined className={style.icon} rotate={270} />}>
			<Text translationNameSpace="listing" translationKey="assignButton" asFragment={true} />
		</Button>
	);
};

export default AssignBtn;
